// extracted by mini-css-extract-plugin
export default {"discoverContent":"Discover_discoverContent__h8xCJ","discoverItem":"Discover_discoverItem__mke87"};